import angular from 'angular';
import individualInfoTemplate from './individualInfo.template.html';

export default angular
  .module('csm.books.com.individualInfo', [])
  .component('individualInfo', {
    bindings: {
      addressEntity: '<'
    },
    template: individualInfoTemplate,
    controller: individualInfoController
  }).name;

/* @ngInject */ function individualInfoController($injector, $scope) {
  const $ctrl = this;
  const $svcs = { $ctrl };

  // Initialize component data
  $ctrl.$onInit = function () {
    $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs }));
  };
}

/* @ngInject */ function initCtrl($ctrl, $injector, $svcs, SERVER) {
   /**
   * If the entity is a student then we show a section of inputs of all
   * the student information. Grade, Student ID, Funds.
   */
  const entityIsAStudent =
    $ctrl.addressEntity &&
    $ctrl.addressEntity.entity.types.some(
      (type) => type === SERVER.BooksDBConstants.ET_STUDENT
    );

  Object.assign($ctrl, {
    // Properties
    entityIsAStudent
  });
}